import {takeEvery} from 'redux-saga/effects'

import {GET_ACCOUNT_LIST} from '../../../Actions/Account/ActionType/ApiActionTypes'
import fetchData from '../../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_ACCOUNT_LIST, fetchData)
}
export default dataSaga
